export enum ProvinceIdEnum {
  Alberta = 1,
  BC = 2,
  Manitoba = 3,
  NewBrunswick = 4,
  Newfoundland = 5,
  NovaScotia = 6,
  Ontario = 7,
  PEI = 8,
  Quebec = 9,
  Saskatchewan = 10,
  NorthwestTerritories = 11,
  Nunavit = 12,
  Yukon = 13
}
